import React, { useState, useEffect } from "react";
import SummaryBlock from "../../components/SummaryBlock/SummaryBlock";
import Headline from "../../components/Title/Headlines";
import CONSTANTS from "../../Constants";
import { isMobile } from "../../helpers/helpers";
import './YourAppointmentPage.scss'
import fetchApiData from "../../apiHandlers/fetchApiData";
import Moment from 'moment'
import MonthsDropDown from "../../components/Calendar/MonthsDropDown";
import { useSelector, useDispatch } from "react-redux";
import { GoogleMap, Marker } from "@react-google-maps/api";
import APActiveDealerLocatorPin from '../../images/AP/ap-active-dealerLocator-pin.svg'
import { Button } from "../../components/Forms/Forms";
import { useParams, useNavigate } from "react-router-dom";
import StickyButton from "../../components/Forms/StickyButton";
import { setAppointmentDetails, setDealerDetails, setVeiculeInfos, setSelectedMileageStep, setPersonalInformations, setSelectedOperationsToStore, setIsFromLink, setSelectedForfaitsToStore, setSelectedMandatoryAdditionalForfaitsToStore, setBasketId } from "../../redux-files/actions/action";
import { pushToGTMTracker, pushEventToGTM } from "../../helpers/trackerManager";

const YourAppointemetPage = ({ isRdvFormQuotingMail }) => {
    const dealerfromStore = useSelector(state => state.ndel_store.dealer)
    const AppointmentInfosFromStore = useSelector(state => state.ndel_store.appointment)
    const [selectedDate, setSelectedDate] = useState(new Date())
    const [slots, setSlots] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [slotsHoursToShow, setSlotsHoursToShow] = useState(15)
    const [dealer, setDealer] = useState(dealerfromStore)
    const [Appointment, setAppointment] = useState(AppointmentInfosFromStore || {})
    const [diablePrevArrow, setDiablePrevArrow] = useState(true)
    const [diableNextArrow, setDiableNextArrow] = useState(false)
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const params = useParams()

    useEffect(() => {
        console.log('useEffect run YourAPPointmentPage ...')
        if (isRdvFormQuotingMail) {
            setIsLoading(true)
            getQuoteBasket()
        } else {
            getCreneauxDispo(new Date())
        }
        window.scrollTo(0, 0)
        pushToGTMTracker('appointment-page', window.siteConfig.quotingRdv.Title.replace('[nom-marque]', CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()), dealer)
    }, [])
    useEffect(() => {
        let date = new Date()
        let newDate = new Date(Moment(selectedDate).add(7, 'days').format())
        if (selectedDate.getTime() > date.getTime()) {
            setDiablePrevArrow(false)
        } else {
            setDiablePrevArrow(true)
        }
        date.setMonth(date.getMonth() + 12)
        date.setDate(0)
        if (newDate.getTime() > date.getTime()) {
            setDiableNextArrow(true)
        } else {
            setDiableNextArrow(false)
        }
    }, [selectedDate])
    const getQuoteBasket = () => {
        const fetchQuoteBasket = new fetchApiData();
        let data = {
            idQuote: params.idQuote,
            token: params.token
        }
        fetchQuoteBasket.getQuoteBasket(data).then(
            res => {
                getCreneauxDispo(new Date(), res.d.dealer.iD)
                let TempSelectedServices = [...res.d.SelectedServices]
                let selectedServices = TempSelectedServices.map(service => {
                    service.interventionForfaits = service.forfaits;
                    delete service.forfaits;
                    return service;
                })
                let selectedForfaits = []
                let selectedMandatoryOperations = []
                selectedServices.map(service => {
                    let selectedForfait = service.interventionForfaits[0].SubFunctionList[0].ForfaitList.filter(forfait =>
                        forfait.isSelected
                    )
                    selectedForfait.forEach(forfait => {
                        forfait.isChecked = forfait.isSelected;
                        forfait.forfaitFamilyCode = service.interventionForfaits[0].SubFunctionList[0].Code
                        delete forfait.isSelected;
                        if (service.interventionForfaits[0].isConstructeur) {
                            selectedMandatoryOperations = forfait.Operations.filter(mandatoryOperation => mandatoryOperation.isSelected)
                            selectedMandatoryOperations.forEach(mandOper => {
                                mandOper.isChecked = mandOper.isSelected;
                                mandOper.ParentRef = forfait.ParentRef
                                delete mandOper.isSelected;
                            })
                        }
                    })
                    selectedForfaits = [...selectedForfaits, ...selectedForfait]
                    return selectedForfaits
                })
                setDealer(res.d.dealer)
                dispatch(setDealerDetails({ ...res.d.dealer, listPremiumServices: res.d.dealer.ListeIdSP }))
                dispatch(setVeiculeInfos({ ...res.d.car, contratService: res.d.kilo.contratService }))
                dispatch(setSelectedMileageStep({
                    key: res.d.codePas,
                    value: ""
                }))
                dispatch(setPersonalInformations({ email: res.d.personalInfos.mail }))
                dispatch(setSelectedOperationsToStore(selectedServices))
                dispatch(setSelectedForfaitsToStore(selectedForfaits))
                dispatch(setSelectedMandatoryAdditionalForfaitsToStore(selectedMandatoryOperations))
                dispatch(setIsFromLink(true))
                dispatch(setBasketId(data.idQuote))
            })
            .catch(error => {
                console.error(error)
            })
    }
    const getCreneauxDispo = (newDate, dealerId = dealer.iD) => {
        const fetchSlots = new fetchApiData();
        setIsLoading(true)
        fetchSlots.getCreneauxDispo(dealerId, newDate)
            .then(
                res => {
                    setIsLoading(false)
                    setSlots(process.env.NODE_ENV !== 'production' ? (res.d)[0].days : JSON.parse(res.d)[0].days)
                    setSelectedDate(newDate)
                })
            .catch(error => {
                setIsLoading(false)
                console.error(error)
            });
    }

    const onMonthClick = (month) => {
        getCreneauxDispo(new Date(month))
    }

    const nextOrPrevWeek = (date, step) => {
        let daysToAdd = (step === 'next' ? 7 : -7);
        let newDate = new Date(Moment(date).add(daysToAdd, 'days').format())
        getCreneauxDispo(newDate)
    }
    const onChangeDealer = () => {
        dispatch(setDealerDetails({
            ...dealerfromStore,
            editDealer: true,
            isFromAppointmentPage: true
        }))
        navigate(CONSTANTS.SITE_ROUTS.OPERATIONSPAGE)
    }

    const google = window.google;
    let _marker = new Object({
        iconActive: APActiveDealerLocatorPin,
        size: (google.maps ? new google.maps.Size(80, 80) : false),
        scaledSize: (google.maps ? new google.maps.Size(80, 80) : false),
        origin: (google.maps ? new google.maps.Point(0, 0) : false)
    });

    const mapStyles = {
        height: "632px",
        maxWidth: "1280px",
        margin: "auto"
    };

    let maxHoursSlotsLength = 0
    for (let i = 0; i < slots.length; i++) {
        if (slots[i].hours.length >= maxHoursSlotsLength) {
            maxHoursSlotsLength = slots[i].hours.length
        }
    }
    const LoadingClass = (isLoading ? " Loading" : "");
    // const disablePrevArrowClass = (diablePrevArrow ? " Loading" : "");
    return (
        <>
            <SummaryBlock showAppointmentBlock={true} />
            <Headline
                Title={!isMobile() ? CONSTANTS.LABELS.quote_booking : CONSTANTS.LABELS.multislots_select_slot}
                SubTitle={!isMobile() ? CONSTANTS.LABELS.multislots_quote_subtitle : ''}
            />
            <div className='appointment-wrapper'>
                <div className='content-container'>
                    <div className={`calendar-block ${LoadingClass}`}>
                        <p tabIndex="0" className='happyHour-paragraph' dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.multislots_happy_hours_desktop) }}>
                        </p>
                        <div className={`calendar-container`}>
                            <MonthsDropDown handleMonthClick={(month) => onMonthClick(month)} selectedDateProp={selectedDate} />
                            <div className={`calendar-week`}>
                                <div
                                    style={{ pointerEvents: diablePrevArrow ? 'none' : '' }}
                                    className={`calendar-arrows arrow-left ${diablePrevArrow}`}
                                    onClick={() => nextOrPrevWeek(selectedDate, 'prev')}
                                />
                                <ul className={`calendar-slots`}>
                                    {slots.map(slot => {
                                        const disableSundayClass = Moment(slot.dayDate, 'D/M/Y').day() === 0 ? 'disableSunday' : ''
                                        return (
                                            <li key={slot.dayDate} className='day-item' >
                                                <div className={`day-name ${disableSundayClass}`}>
                                                    <div>{Moment(slot.dayDate, 'D/M/Y').format('ddd')}</div>
                                                    <div>{Moment(slot.dayDate, 'D/M/Y').format('D')}</div>
                                                </div>
                                                {slot.hours.slice(0, slotsHoursToShow).map((hour, index) => {
                                                    const disabledHourSlot = hour.time === 'false' ? 'disabled-slot' : ''
                                                    const happyHourSlot = hour.isHappy !== 'false' ? 'happyHour-slot' : ''
                                                    const isSelectedSlot = (Appointment.dayDate === slot.dayDate && Appointment.hour === hour.time) ? 'selected' : ''
                                                    return (
                                                        <div key={index}
                                                            tabIndex='0'
                                                            role="button"
                                                            className={`day-slots ${disabledHourSlot} ${happyHourSlot} ${isSelectedSlot}`}
                                                            data-deal={(hour.isHappy !== 'false' ? hour.isHappy : '')}
                                                            onClick={() => {
                                                                setAppointment({ dayDate: slot.dayDate, hour: hour.time, happyHour: hour.isHappy == 'false' ? false : hour.isHappy.slice(0, -1) });
                                                            }
                                                            }
                                                            onKeyDown = {(e)=> e.key === 'Enter' && setAppointment({ dayDate: slot.dayDate, hour: hour.time, happyHour: hour.isHappy == 'false' ? false : hour.isHappy.slice(0, -1) })}
                                                        >
                                                            <span className='slot'>{hour.time}</span>
                                                        </div>
                                                    )
                                                })
                                                }
                                            </li>

                                        )
                                    })}
                                </ul>
                                <div
                                    style={{ pointerEvents: diableNextArrow ? 'none' : '' }}
                                    className={`calendar-arrows arrow-right`}
                                    onClick={() => nextOrPrevWeek(selectedDate, 'next')}
                                />
                            </div>
                            {slots.every(slot => slot.hours.length <= 0) ?
                                !isLoading && <div className='empty-slots-container'>
                                    <h3 className='slots-empty-title' dangerouslySetInnerHTML={{ __html: CONSTANTS.LABELS.multislots_noslots }}></h3>
                                    <p className='warning' dangerouslySetInnerHTML={{ __html: CONSTANTS.LABELS.summary_warning_alert_dealer }}></p>

                                    <Button
                                        handlClick={onChangeDealer}
                                        isDisabled={false}>
                                        {CONSTANTS.LABELS.quote_alert_dealer}
                                    </Button>
                                </div>
                                : <div className='show-more-link' onClick={() => {
                                    (maxHoursSlotsLength >= slotsHoursToShow) ? setSlotsHoursToShow(slotsHoursToShow + 10) : setSlotsHoursToShow(15)
                                }}>
                                    {(maxHoursSlotsLength >= slotsHoursToShow) ? CONSTANTS.LABELS.multislots_see_more_slots : CONSTANTS.LABELS.multislots_see_less_slots}
                                </div>}
                        </div>
                    </div>

                    {!isMobile() && <div className='map-block'>
                        <GoogleMap
                            mapContainerStyle={mapStyles}
                            zoom={14}
                            center={{ lat: Number(dealer.position.lat), lng: Number(dealer.position.lng) }}
                            options={{ mapTypeControl: false, streetViewControl: false, }}
                        >
                            <Marker
                                position={{ lat: Number(dealer.position.lat), lng: Number(dealer.position.lng) }}
                                title={dealer.Name}
                                options={{ optimized: false }}
                                icon={new Object({
                                    url: _marker.iconActive,
                                    size: _marker.size,
                                    scaledSize: _marker.scaledSize,
                                    origin: _marker.origin
                                })}
                                key={dealer.DealerId}
                            />
                        </GoogleMap>
                    </div>}
                </div>
            </div>
            <StickyButton
                link={CONSTANTS.SITE_ROUTS.PERSONNALDETAILSPAGE}
                label={CONSTANTS.LABELS.common_v2_continue}
                isDisabled={Object.values(Appointment).length <= 0}
                handleClick={() => {
                    dispatch(setAppointmentDetails(Appointment))
                    pushEventToGTM({
                        pageName: 'appointment',
                        eventAction: 'Redirection::Internal::Next_step',
                        eventLabel: CONSTANTS.LABELS.common_v2_continue,
                        eventCategory: 'Content'
                    })
                }
                }
            />
        </>
    )
}
export default YourAppointemetPage;